import { nr as n, m as f, E as o } from "./abstract-base-0be59b32-472aea73.js";
var u = Object.defineProperty, v = Object.getOwnPropertyDescriptor, l = (p, t, i, r) => {
  for (var e = r > 1 ? void 0 : r ? v(t, i) : t, a = p.length - 1, c; a >= 0; a--)
    (c = p[a]) && (e = (r ? c(t, i, e) : c(e)) || e);
  return r && e && u(t, i, e), e;
};
class s extends n(f) {
  constructor() {
    super(...arguments), this.index = 0, this.label = "", this.color = "", this.value = "";
  }
}
l([
  o({ reflect: !0 })
], s.prototype, "index", 2);
l([
  o({ reflect: !0 })
], s.prototype, "label", 2);
l([
  o({ reflect: !0 })
], s.prototype, "color", 2);
l([
  o({ reflect: !0 })
], s.prototype, "value", 2);
export {
  s
};
